import { StatsigClient } from '@statsig/js-client';

export const GEOCOMPLY_FEATURE_GATE_NAME = 'web_geocomply';
export const GEOCOMPLY_UI_GATE_NAME = 'web_geocomply_ui';

/**
 * Imperative master-gate read for the GeoComply shadow rollout.
 *
 * Missing or not-yet-initialized Statsig state intentionally defaults off so
 * the integration remains inert and trading stays fail-open.
 */
export function isGeoComplyFeatureEnabled(): boolean {
    return StatsigClient.instance()?.checkGate(GEOCOMPLY_FEATURE_GATE_NAME) ?? false;
}

/**
 * Enables user-visible intervention and the matching fail-closed request guard.
 *
 * Requiring the master gate as well prevents the UI gate from activating
 * GeoComply by itself while the shadow rollout is incomplete.
 */
export function isGeoComplyUiEnabled(): boolean {
    const client = StatsigClient.instance();
    if (!client?.checkGate(GEOCOMPLY_FEATURE_GATE_NAME)) return false;

    return client.checkGate(GEOCOMPLY_UI_GATE_NAME);
}
